import { argbFromHex, Hct, hexFromArgb } from '@material/material-color-utilities';
import Color, { ColorInstance } from 'color';
import { isChartTestMode } from './consts';

class NextColorGetter {
    private static toneList = [95, 90, 85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 30, 25, 20];
    private static minToneIndex = 0;
    private static maxToneIndex = NextColorGetter.toneList.length - 1;

    private source = Color('#ffffffff');
    /** 游标 */
    private currentToneIndex = 0;
    /** 游标方向 */
    private currentToneDir: 'left' | 'right' = 'left';

    private static getToneIndex = (color: ColorInstance) => {
        const { tone } = Hct.fromInt(argbFromHex(color.hex()));
        isChartTestMode && console.log('===NextColorGetter.currentTone', tone);
        let currentIndex = NextColorGetter.toneList.findIndex((v) => v <= tone);
        if (currentIndex === -1) {
            currentIndex = NextColorGetter.toneList.length - 1;
        }
        return currentIndex;
    };

    resetSource = (source: string) => {
        const color = Color(source);
        const toneIndex = NextColorGetter.getToneIndex(color);

        this.source = color;
        this.currentToneIndex = toneIndex;
        this.currentToneDir = toneIndex <= NextColorGetter.minToneIndex ? 'right' : 'left';
        isChartTestMode &&
            console.log('===NextColorGetter.resetSource', {
                source,
                toneIndex,
                currentToneDir: this.currentToneDir,
            });
    };

    useNextColor = (): ColorInstance => {
        let newToneDir = this.currentToneDir;
        if (this.currentToneDir === 'left' && this.currentToneIndex <= NextColorGetter.minToneIndex) {
            newToneDir = 'right';
        } else if (this.currentToneDir === 'right' && this.currentToneIndex >= NextColorGetter.maxToneIndex) {
            newToneDir = 'left';
        }
        const nextToneIndex = this.currentToneIndex + (newToneDir === 'right' ? 1 : -1);
        const hctInstance = Hct.fromInt(argbFromHex(this.source.hex()));
        const newTone = NextColorGetter.toneList[nextToneIndex];
        isChartTestMode && console.log('===NextColorGetter.newTone', newTone);
        hctInstance.tone = newTone;
        const nextColor = Color(hexFromArgb(hctInstance.toInt()));

        this.currentToneIndex = nextToneIndex;
        this.currentToneDir = newToneDir;

        return nextColor;
    };
}

export const nextColorGetter = new NextColorGetter();
isChartTestMode && ((window as any).nextColorGetter = nextColorGetter);
